<template>
  <div>
    <h4>{{$t('deleteAccount')}}</h4>
    <div class="box-block">
      <p>
      {{$t('deleteAccountIntro')}}
      </p>
      <ValidationObserver ref="observer"  v-slot="{ invalid }">
        <form class="mb-3">
          <div class="form-group">
            <div class="bank-transfer">
              <h5 class="mb-0">texte:</h5>
              <div>{{$t('deleteAccountText')}}</div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6">
              <div class="form-group">
                <validation-provider
                  name="text"
                  rules="required|is:JE VEUX SUPPRIMER MON COMPTE"
                  v-slot="{ errors }"
                >
                  <label for="text" 
                    >{{$t('deleteAccountMessage')}}</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.length }"
                    v-model="text"
                    placeholder="Texte"
                    id="text"
                  />
                  <span class="text-danger small">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="mt-3 d-flex justify-content-between">
            <button
              type="submit"
              class="btn btn-outline-secondary"
              :disabled="invalid"
              @click.stop.prevent="deletAccount"
            >
              {{$t('buttons.deleteAccountButton')}}
            </button>
            <div v-if="monitor.visible" :class="monitor.type">
              {{ monitor.message }}
            </div>
            <div></div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import Qs from 'qs'
export default {
  name: "remove-profile",
  data() {
    return {
      text: "",
      monitor: {
        visible: false,
        message: "",
        type: "text-warning",
      },
    };
  },
  computed: {
    ...mapFields(['user', 'cart']),
  },
  methods: {
    deletAccount() {
      this.$store.dispatch('deletAccount')
      .then(() => {
        this.monitor.type = "text-success";
        this.monitor.message = this.$t('deleteAccountSuccessMessage');
        this.monitor.visible = true;
        setTimeout(() => {
          this.user = null
          this.clearCart()
          window.location = "/";
        }, 1500);
      })
      .catch((error) => {
        this.monitor.type = "text-danger";
        this.monitor.message = this.$t('errors.serverError');;
        this.monitor.visible = true;
        console.log(error);
        setTimeout(() => {
          this.monitorHide()
        }, 1500)
      });
    },
    clearCart() {
      this.$store.commit('CLEAR_CART')
      this.$store.commit('SET_STEP', 0)
    },
    monitorHide() {
      this.monitor.type = ''
      this.monitor.message = ''
      this.monitor.visible = false
    },
  }
}
</script>

<style>
</style>